import React from "react";

const ACCENT = "#BEE362"; // your green
const NAVY = "#1A4564";   // your navy
import imageSrc1 from '../../Images/security.png'
// --- tiny inline icons (no libs) ---
const ShieldBadge = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <path
      d="M12 2 20 6v6c0 5-3.4 9.4-8 10-4.6-.6-8-5-8-10V6l8-4Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M9 12l2 2 4-5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckCircle = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <path
      d="M12 22a10 10 0 1 0-10-10 10 10 0 0 0 10 10Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M8 12l2.5 2.5L16.5 9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function Trsut({
  titleSmall = "VERTRAUEN & SICHERHEIT",
  title = "Warum mit uns arbeiten?",
  points = [
    "Individuelle Lösungen (keine Standard-Tools)",
    "DSGVO-konforme Umsetzung",
    "Transparente Prozesse",
    "Persönliche Betreuung",
  ],
  primaryCta = "Jetzt starten",
  secondaryCta = "Kontaktieren",
  // Replace this with your own image:
  imageSrc = imageSrc1,
}) {
  return (
    <section className="w-[70%] 2xl:w-[50%] mx-auto py-10 sm:py-14 bg-white">
      <div className="relative overflow-hidden rounded-[28px] bg-[#081827] ring-1 ring-white/10 shadow-[0_18px_70px_rgba(0,0,0,0.35)]">
        {/* background glow */}
        <div
          className="pointer-events-none absolute -left-40 -top-40 h-[420px] w-[420px] rounded-full blur-3xl opacity-25"
          style={{ background: ACCENT }}
        />
        <div
          className="pointer-events-none absolute -right-40 -bottom-40 h-[520px] w-[520px] rounded-full blur-3xl opacity-25"
          style={{ background: NAVY }}
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black/55 via-black/20 to-transparent" />

        <div className="relative grid gap-10 p-7 sm:p-10 lg:grid-cols-12 lg:gap-12">
          {/* LEFT */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3">
              <span
                className="grid h-9 w-9 place-items-center rounded-xl ring-1 ring-white/15 bg-white/5"
                style={{
                  boxShadow: "0 0 0 1px rgba(255,255,255,.05) inset",
                }}
              >
                <ShieldBadge className="h-5 w-5" style={{ color: ACCENT }} />
              </span>

              <p className="text-sm font-semibold tracking-wide text-white/70">
                {titleSmall}
              </p>
            </div>

            <h2 className="mt-4 h2-mb h2-md h2-lg h2-2xl !text-white">
              {title}
            </h2>

            <ul className="mt-8 space-y-5">
              {points.map((t, idx) => (
                <li key={idx} className="flex items-start gap-4">
                  <span
                    className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-full ring-1 ring-white/15"
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(190,227,98,0.22), rgba(190,227,98,0.08))",
                    }}
                  >
                    <CheckCircle className="h-5 w-5" style={{ color: ACCENT }} />
                  </span>
                  <p className="text-base leading-relaxed text-white/85">
                    {t}
                  </p>
                </li>
              ))}
            </ul>

            {/* Buttons */}
            
          </div>

          {/* RIGHT */}
          <div className="lg:col-span-5">
            <div className="relative h-full overflow-hidden rounded-[28px] bg-white/5 ring-1 ring-white/10">
              {/* Replace this image */}
              <img
                src={imageSrc}
                alt="Trust illustration"
                className="h-72 w-full object-cover sm:h-96 lg:h-full"
              />

              {/* subtle overlay / vignette like reference */}
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-black/30 via-transparent to-transparent" />
              <div className="pointer-events-none absolute inset-0 shadow-[inset_0_0_0_1px_rgba(255,255,255,0.06)]" />
            </div>
          </div>
        </div>

        {/* bottom accent line */}
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-px opacity-70"
          style={{
            background:
              "linear-gradient(90deg, transparent, rgba(190,227,98,0.55), transparent)",
          }}
        />
      </div>
    </section>
  );
}
